import { proxyCustomElement, HTMLElement, h, Fragment } from '@stencil/core/internal/client';

const clDataTableRowCollapseCss = ":host(cl-data-table-row-collapse){display:table-row}:host(cl-data-table-row-collapse) .container{display:grid;grid-template-rows:0fr;transition:grid-template-rows var(--animation-duration-fast) ease-in-out}:host(cl-data-table-row-collapse) .container__content{overflow:hidden}@supports (background: -webkit-named-image(i)){:host(cl-data-table-row-collapse) .container__content{display:none}}:host(cl-data-table-row-collapse):host([expand=true]) .container{grid-template-rows:1fr}@supports (background: -webkit-named-image(i)){:host(cl-data-table-row-collapse):host([expand=true]) .container .container__content{display:grid}}:host(cl-data-table-row-collapse):host([expand=\"\"]) .container{grid-template-rows:1fr}@supports (background: -webkit-named-image(i)){:host(cl-data-table-row-collapse):host([expand=\"\"]) .container .container__content{display:grid}}";

const ClDataTableRowCollapse$1 = /*@__PURE__*/ proxyCustomElement(class ClDataTableRowCollapse extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.expand = false;
    this.rowIndex = undefined;
  }
  render() {
    return (h(Fragment, null, h("td", { colSpan: 100, style: { padding: '0' } }, h("div", { class: 'container' }, h("div", { class: 'container__content' }, h("slot", null))))));
  }
  static get style() { return clDataTableRowCollapseCss; }
}, [1, "cl-data-table-row-collapse", {
    "expand": [516],
    "rowIndex": [2, "row-index"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-data-table-row-collapse"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-data-table-row-collapse":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDataTableRowCollapse$1);
      }
      break;
  } });
}

const ClDataTableRowCollapse = ClDataTableRowCollapse$1;
const defineCustomElement = defineCustomElement$1;

export { ClDataTableRowCollapse, defineCustomElement };

//# sourceMappingURL=cl-data-table-row-collapse.js.map